import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { hotEvents } from "@/mocks/guagua";

export default function HotEventsSection() {
  const [featured, ...rest] = hotEvents;
  const list = rest.slice(0, 5);

  return (
    <section id="hot" className="w-full scroll-mt-20 border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="今日热度榜"
            title="网爆吃瓜热门事件"
            description="按讨论热度整理的当下热点，每个合集都包含话题背景、时间线与看点清单，先看要点再决定是否深看。"
          />
          <Link
            to="/collections"
            className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-full border border-primary-300 bg-primary-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 md:self-auto"
          >
            查看全部合集
            <i className="ri-arrow-right-line leading-none" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-6">
            <Link to={`/collection/${featured.id}`} className="block">
              <div className="relative h-60 w-full overflow-hidden md:h-72">
                <img
                  src={featured.cover}
                  alt={`${featured.title} 合集配图`}
                  title={`${featured.title} - 网爆吃瓜热门事件`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-fire-fill leading-none" aria-hidden="true"></i>
                  热度第一
                </span>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
                    {featured.categoryName}
                  </span>
                  <span>{featured.date} 更新</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line leading-none" aria-hidden="true"></i>
                    {featured.heat} 热度
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700 transition-all group-hover:gap-2">
                  立即看合集
                  <i className="ri-arrow-right-line leading-none" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          </article>

          <div className="flex flex-col gap-3 lg:col-span-6">
            {list.map((item, index) => (
              <article
                key={item.id}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 md:p-4"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                    index === 0
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-100 text-foreground-700"
                  }`}
                >
                  {index + 2}
                </span>
                <Link to={`/collection/${item.id}`} className="min-w-0 flex-1">
                  <h3 className="truncate font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="mt-1 line-clamp-1 text-sm text-foreground-600">{item.summary}</p>
                  <div className="mt-1.5 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="text-primary-600">{item.categoryName}</span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-fire-line leading-none" aria-hidden="true"></i>
                      {item.heat}
                    </span>
                    <span>{item.date}</span>
                  </div>
                </Link>
                <i
                  className="ri-arrow-right-s-line hidden shrink-0 text-2xl text-foreground-300 transition-colors group-hover:text-primary-500 sm:block leading-none"
                  aria-hidden="true"
                ></i>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}